<section class="opportunities-page" *ngIf="isPreOrderPage">
    <header class="op-intro">
        <vsf-breadcrumbs [items]="[{ label: 'Home', link: '/' }, { label: 'Pre-Order Opportunities' }]"></vsf-breadcrumbs>
        <h1>Pre-Order Opportunities</h1>
        <p>We show the 1–5 best pre-order offers per brand, so brands are easier to compare.</p>
    </header>
    <div class="op-toolbar">
        <div class="op-stats">
            <span
                ><b>{{ brandCount | number }}</b> brands</span
            ><span class="op-mobile-label">·</span
            ><span
                ><b>{{ activeOfferCount | number }}</b> active pre-orders</span
            ><span class="op-mobile-label">·</span
            ><span
                ><b>{{ totalSkus == null ? "—" : (totalSkus | number) }}</b> SKUs</span
            ><span class="op-updated"><i></i>Updated daily</span>
        </div>
        <div class="op-actions">
            <vsf-export-download-menu
                label="Download full catalog"
                buttonClass="op-action"
                iconSrc="assets/icons/download-icon.svg"
                [showShareLink]="true"
                ariaLabel="Download full catalog"
                (download)="downloadAllProducts($event)"
                (shareLink)="onShareCatalog($event)"
            ></vsf-export-download-menu
            ><button
                type="button"
                class="op-action"
                (click)="downloadPreorderBrandlists()"
                [disabled]="loading || downloadingBrandReport || !pricelists.length"
            >
                <svg
                    class="op-icon"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                >
                    <use href="assets/icons/opportunities-sprite.svg#download"></use></svg
                >Download pre-order brand portfolio</button
            ><vsf-upload-cart-csv
                *ngIf="isLoggedIn"
                buttonLabel="Import cart"
                [borderedToolbar]="true"
                customClass="op-action"
            ></vsf-upload-cart-csv
            ><a
                *ngIf="!isLoggedIn"
                class="op-action"
                routerLink="/account/sign-in"
                [queryParams]="{ returnUrl: '/pricelists/pre-order' }"
                ><svg
                    class="op-icon"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                >
                    <use href="assets/icons/opportunities-sprite.svg#upload"></use></svg
                >Import cart</a
            >
        </div>
    </div>
    <div class="op-mobile-brand">
        <button
            type="button"
            class="op-brand-toggle"
            (click)="toggleFilters()"
            [attr.aria-expanded]="filtersExpanded"
        >
            <svg
                class="op-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
            >
                <use href="assets/icons/opportunities-sprite.svg#search"></use></svg
            >Filter by brand <span>{{ brandCount | number }} brands</span>
        </button>
        <div class="op-brand-pills">
            <button
                *ngFor="let brand of brandOptions.slice(0, 8)"
                type="button"
                [class.active]="selectedBrands.has(brand)"
                (click)="toggleOpportunityBrand(brand)"
            >
                {{ brand }}<span *ngIf="selectedBrands.has(brand)">×</span>
            </button>
        </div>
    </div>
    <div class="op-mobile-controls">
        <div class="preorder-menu">
            <button
                type="button"
                class="op-menu-trigger"
                (click)="opportunityMenu = opportunityMenu === 'mov' ? null : 'mov'"
                [attr.aria-expanded]="opportunityMenu === 'mov'"
            >
                MOQ <span>{{ appliedMov ? opportunityMovLabel() : "" }}</span
                ><i class="op-triangle"></i></button
            ><ng-container *ngTemplateOutlet="movMenu"></ng-container>
        </div>
        <div class="preorder-menu">
            <button
                type="button"
                class="op-menu-trigger"
                (click)="opportunityMenu = opportunityMenu === 'eta' ? null : 'eta'"
                [attr.aria-expanded]="opportunityMenu === 'eta'"
            >
                ETA <span>{{ appliedEta ? opportunityEtaLabel() : "" }}</span
                ><i class="op-triangle"></i></button
            ><ng-container *ngTemplateOutlet="etaMenu"></ng-container>
        </div>
    </div>
    <div class="op-layout">
        <aside class="op-sidebar" [class.op-sidebar--open]="filtersExpanded">
            <div class="op-sidebar-heading">
                <strong>Filters</strong
                ><button type="button" (click)="clearOpportunityFilters()">Clear all</button>
            </div>
            <div class="op-filter-box">
                <h2>Brand</h2>
                <label class="op-brand-search"
                    ><svg
                        class="op-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        aria-hidden="true"
                    >
                        <use href="assets/icons/opportunities-sprite.svg#search"></use></svg
                    ><input
                        type="search"
                        [(ngModel)]="sidebarBrandSearch"
                        placeholder="Search brands..."
                        aria-label="Search brands" /></label
                ><label class="op-checkbox" *ngFor="let brand of sidebarBrands"
                    ><input
                        type="checkbox"
                        [checked]="selectedBrands.has(brand)"
                        (change)="toggleOpportunityBrand(brand)"
                    /><span>{{ brand }}</span
                    ><small>{{ brandOfferCount(brand) }}</small></label
                ><button
                    type="button"
                    class="op-show-more"
                    *ngIf="brandOptions.length > 5"
                    (click)="showAllBrands = !showAllBrands"
                >
                    {{ showAllBrands ? "Show less" : "Show more" }}
                </button>
            </div>
            <div class="op-filter-box">
                <h2>Category</h2>
                <label class="op-checkbox" *ngFor="let category of categoryOptions"
                    ><input
                        type="checkbox"
                        [checked]="selectedCategories.has(category)"
                        (change)="toggleCategory(category)"
                    /><span>{{ category }}</span
                    ><small>{{ categoryCount(category) }}</small></label
                >
                <p *ngIf="!categoryOptions.length" class="op-muted">
                    {{ metricsLoading ? "Loading categories…" : "No category data available" }}
                </p>
            </div>
            <div class="op-filter-box">
                <h2>Featured</h2>
                <label class="op-checkbox"
                    ><input
                        type="checkbox"
                        [checked]="featuredOnly"
                        (change)="toggleFeatured()"
                    /><span>Featured pre-orders only</span><small>{{ featuredCount }}</small></label
                >
            </div>
            <div class="op-filter-box op-desktop-label">
                <h2>Minimum order</h2>
                <div class="preorder-menu">
                    <button
                        type="button"
                        class="op-menu-trigger"
                        (click)="opportunityMenu = opportunityMenu === 'mov' ? null : 'mov'"
                        [attr.aria-expanded]="opportunityMenu === 'mov'"
                    >
                        {{ opportunityMovLabel() }}<i class="op-triangle"></i></button
                    ><ng-container *ngTemplateOutlet="movMenu"></ng-container>
                </div>
            </div>
            <div class="op-filter-box op-desktop-label">
                <h2>ETA</h2>
                <div class="preorder-menu">
                    <button
                        type="button"
                        class="op-menu-trigger"
                        (click)="opportunityMenu = opportunityMenu === 'eta' ? null : 'eta'"
                        [attr.aria-expanded]="opportunityMenu === 'eta'"
                    >
                        {{ opportunityEtaLabel() }}<i class="op-triangle"></i></button
                    ><ng-container *ngTemplateOutlet="etaMenu"></ng-container>
                </div>
            </div>
        </aside>
        <main class="op-results">
            <div class="op-results-heading">
                <div class="op-chips">
                    <button
                        *ngFor="let chip of opportunityChips"
                        type="button"
                        (click)="removeOpportunityChip(chip.id)"
                    >
                        {{ chip.label
                        }}<svg
                            class="op-icon"
                            width="9"
                            height="9"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            aria-hidden="true"
                        >
                            <use href="assets/icons/opportunities-sprite.svg#close"></use>
                        </svg></button
                    ><button
                        class="op-clear"
                        *ngIf="opportunityChips.length"
                        type="button"
                        (click)="clearOpportunityFilters()"
                    >
                        Clear all
                    </button>
                </div>
                <p>
                    <svg
                        class="op-icon"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.8"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        aria-hidden="true"
                    >
                        <use href="assets/icons/opportunities-sprite.svg#info"></use></svg
                    >Expand each brand to compare MOQ, ETA and product availability.
                </p>
            </div>
            <div class="op-loading" *ngIf="loading" role="status">
                Loading pre-order opportunities…
            </div>
            <div class="op-empty" *ngIf="!loading && !brandGroups.length">
                <p>No pre-order offers match your filters.</p>
                <button type="button" (click)="clearOpportunityFilters()">Clear all filters</button>
            </div>
            <div class="op-table-wrap" *ngIf="!loading && brandGroups.length">
                <div class="op-table" [class.op-table--guest]="showGuestUnlock">
                    <div class="op-table-head">
                        <button type="button" (click)="sortBy('brand')">Brand</button
                        ><button type="button" (click)="sortBy('mov')">Min. Order (from)</button
                        ><button type="button" (click)="sortBy('skus')">SKUs Available</button
                        ><button type="button" (click)="sortBy('retail')">vs. Retail</button
                        ><button type="button" (click)="sortBy('eta')">ETA</button
                        ><span>Action</span>
                    </div>
                    <article
                        class="op-brand-block"
                        *ngFor="
                            let group of paginatedBrandGroups;
                            let i = index;
                            trackBy: trackByBrand
                        "
                    >
                        <button
                            type="button"
                            class="op-brand-row"
                            (click)="toggleBrand(group.name)"
                            [attr.aria-expanded]="isGroupOpen(group.name, i)"
                        >
                            <span class="op-brand-name"
                                ><span
                                    class="op-chevron"
                                    [class.op-chevron--open]="isGroupOpen(group.name, i)"
                                    ><svg
                                        class="op-icon"
                                        width="12"
                                        height="12"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="1.8"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        aria-hidden="true"
                                    >
                                        <use
                                            href="assets/icons/opportunities-sprite.svg#chevron"
                                        ></use></svg></span
                                >{{ group.name
                                }}<span class="op-featured" *ngIf="isFeaturedGroup(group)"
                                    >Featured</span
                                ></span
                            ><span class="op-brand-value op-value-mov"
                                ><small>MOV</small>{{ formatMov(group.mov) }}</span
                            ><span class="op-brand-value op-value-skus"
                                ><small>SKUs</small
                                >{{
                                    metricForBrand(group.name)?.skuCount == null
                                        ? "—"
                                        : (metricForBrand(group.name)?.skuCount | number)
                                }}</span
                            ><span
                                class="op-brand-value op-value-retail"
                                [title]="discountTooltip(metricForBrand(group.name))"
                                ><small>vs. retail</small
                                >{{ discountLabel(metricForBrand(group.name)) }}</span
                            ><span class="op-brand-value op-value-eta"
                                ><small>ETA</small>{{ formatGroupEta(group) }}</span
                            ><span class="op-brand-view"
                                >{{
                                    isGroupOpen(group.name, i)
                                        ? "Hide offers"
                                        : offerToggleLabel(group)
                                }}<svg
                                    class="op-icon"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="1.8"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    aria-hidden="true"
                                >
                                    <use
                                        href="assets/icons/opportunities-sprite.svg#arrow"
                                    ></use></svg
                            ></span>
                        </button>
                        <div class="op-offers" *ngIf="isGroupOpen(group.name, i)">
                            <div class="op-offers-head">
                                <span>Offer ID</span><span>Min. Order (from)</span
                                ><span>SKUs Available</span><span>ETA</span><span>Deposit</span
                                ><span>Action</span>
                            </div>
                            <div
                                class="op-offer-row"
                                *ngFor="
                                    let offer of group.offers;
                                    let first = first;
                                    trackBy: trackByPricelist
                                "
                            >
                                <button
                                    type="button"
                                    class="op-offer-id"
                                    (click)="onViewPricelist(offer)"
                                >
                                    {{ offerIdLabel(offer)
                                    }}<svg
                                        class="op-icon"
                                        width="11"
                                        height="11"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="1.8"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        aria-hidden="true"
                                    >
                                        <use
                                            href="assets/icons/opportunities-sprite.svg#external"
                                        ></use>
                                    </svg></button
                                ><span><small>Min. order</small>{{ formatMov(offer.mov) }}</span
                                ><span
                                    ><small>SKUs</small
                                    >{{
                                        metricForOffer(group.name, offer)?.skuCount == null
                                            ? "—"
                                            : (metricForOffer(group.name, offer)?.skuCount | number)
                                    }}
                                    <span class="op-desktop-label">SKUs</span></span
                                ><span><small>ETA</small>{{ formatEta(offer) }}</span
                                ><span
                                    ><small>Deposit</small
                                    >{{ formatDeposit(offer.prePaymentPercentage) }}</span
                                >
                                <div class="op-offer-actions">
                                    <button
                                        type="button"
                                        class="op-view-products"
                                        [class.op-view-products--primary]="first"
                                        (click)="onViewPricelist(offer)"
                                    >
                                        View products</button
                                    ><vsf-export-download-menu
                                        label=""
                                        buttonClass="op-download-offer"
                                        iconSrc="assets/icons/download-icon.svg"
                                        [showShareLink]="true"
                                        [compactMenu]="true"
                                        ariaLabel="Download offer sheet"
                                        [dropdownPosition]="['bottom-right']"
                                        (download)="onDownloadOffer(offer, $event)"
                                        (shareLink)="onShareOffer(offer, $event)"
                                    ></vsf-export-download-menu>
                                </div>
                            </div>
                            <p class="op-offers-note">{{ TEXT.OFFER_FOOTNOTE }}</p>
                        </div>
                    </article>
                </div>
                <div class="op-guest-unlock" *ngIf="showGuestUnlock">
                    <strong>Unlock wholesale offers</strong
                    ><a
                        routerLink="/account/sign-in"
                        [queryParams]="{ returnUrl: '/pricelists/pre-order' }"
                        >Sign in</a
                    >
                </div>
            </div>
            <div class="op-pagination" *ngIf="brandGroups.length">
                <span
                    >Showing {{ showingFrom }} to {{ showingTo }} of
                    {{ brandGroups.length }} brands</span
                ><label class="op-page-size"
                    >Show
                    <select
                        aria-label="Brands per page"
                        [ngModel]="itemsPerPage"
                        (ngModelChange)="onItemsPerPageChange($event)"
                    >
                        <option *ngFor="let size of opportunityPageSizes" [value]="size">
                            {{ size }}
                        </option>
                    </select>
                    rows per page</label
                >
                <div class="op-page-controls">
                    <button
                        type="button"
                        aria-label="Previous page"
                        [disabled]="!canGoPrevious"
                        (click)="goToPreviousPage()"
                    >
                        ‹</button
                    ><button
                        type="button"
                        *ngFor="let page of getPageNumbers()"
                        [class.active]="page === currentPage"
                        (click)="goToPage(page)"
                    >
                        {{ page }}</button
                    ><button
                        type="button"
                        aria-label="Next page"
                        [disabled]="!canGoNext"
                        (click)="goToNextPage()"
                    >
                        ›
                    </button>
                </div>
            </div>
        </main>
    </div>
    <section class="op-brand-check">
        <div class="op-brand-check-copy">
            <span class="op-brand-check-icon"
                ><img src="assets/icons/preorder-brand-check.svg" alt=""
            /></span>
            <div>
                <h2>{{ TEXT.BRAND_CHECK_TITLE }}</h2>
                <p>{{ TEXT.BRAND_CHECK_BODY }}</p>
                <button type="button" (click)="openBrandCheck()">Request brand check</button>
            </div>
        </div>
        <div class="op-brand-check-points">
            <div>
                <span><img src="assets/icons/preorder-clock.svg" alt="" /></span>Respond in 1–2
                business days
            </div>
            <div>
                <span><img src="assets/icons/preorder-shield.svg" alt="" /></span>Verified supplier
                network
            </div>
            <div>
                <span><img src="assets/icons/preorder-user.svg" alt="" /></span>Personal account
                manager
            </div>
        </div>
    </section>
    <vsf-contact-form #brandCheckForm></vsf-contact-form>
</section>
<ng-template #movMenu
    ><div class="op-menu" *ngIf="opportunityMenu === 'mov'">
        <button type="button" (click)="setOpportunityMov('')">Any</button
        ><button
            type="button"
            *ngFor="let option of movFilters"
            [class.active]="appliedMov === option.id"
            (click)="setOpportunityMov(option.id)"
        >
            Up to {{ option.label }}
        </button>
    </div></ng-template
>
<ng-template #etaMenu
    ><div class="op-menu" *ngIf="opportunityMenu === 'eta'">
        <button type="button" (click)="setOpportunityEta('')">Any</button
        ><button
            type="button"
            *ngFor="let option of leadTimeFilters"
            [class.active]="appliedEta === option.id"
            (click)="setOpportunityEta(option.id)"
        >
            {{ option.max == null ? option.label : "Up to " + option.label }}
        </button>
    </div></ng-template
>

<div class="pricelists-page" *ngIf="!isPreOrderPage">
    <div class="pricelists-page__header">
        <vsf-breadcrumbs [items]="[{ label: TEXT.HOME, link: '/' }, { label: pageTitle }]"></vsf-breadcrumbs>
        <div class="pricelists-page__actions pricelists-page__actions--desktop">
            <div class="pricelists-page__action-group">
                <vsf-export-download-menu
                    [label]="TEXT.DOWNLOAD_CATALOG"
                    buttonClass="pricelists-page__action-btn"
                    iconSrc="../../../../assets/icons/download-icon.svg"
                    [showShareLink]="true"
                    ariaLabel="Download catalog"
                    (download)="downloadAllProducts($event)"
                    (shareLink)="onShareCatalog($event)"
                ></vsf-export-download-menu>
            </div>
        </div>
        <div class="pricelists-page__actions pricelists-page__actions--mobile">
            <div class="pricelists-page__mobile-menu">
                <button (click)="togglePopup()" class="pricelists-page__mobile-menu-trigger">
                    <img alt="More Actions" src="../../../../assets/icons/more-icon.svg" />
                </button>

                <div *ngIf="isPopupOpen" class="pricelists-page__mobile-menu-dropdown">
                    <div class="pricelists-page__mobile-menu-item">
                        <vsf-export-download-menu
                            [label]="TEXT.DOWNLOAD_CATALOG"
                            buttonClass="pricelists-page__action-btn pricelists-page__action-btn--full"
                            iconSrc="../../../../assets/icons/download-icon.svg"
                            [showShareLink]="true"
                            ariaLabel="Download catalog"
                            (download)="downloadAllProducts($event); closePopup()"
                            (shareLink)="onShareCatalog($event); closePopup()"
                        ></vsf-export-download-menu>
                    </div>

                </div>
            </div>

            <div
                *ngIf="isPopupOpen"
                (click)="closePopup()"
                (keydown.enter)="closePopup()"
                tabindex="0"
                aria-label="Close popup"
                class="pricelists-page__mobile-menu-overlay"
            ></div>
        </div>
    </div>

    <div
        *ngIf="failedProductGtins?.length > 0 || moqViolations?.length > 0"
        class="pricelists-page__error-box"
    >
        <ng-container *ngIf="failedProductGtins?.length > 0">
            <p>{{ TEXT.NOT_FOUND_EANS }}</p>
            <div>
                <p *ngFor="let gtin of failedProductGtins">{{ gtin }}</p>
            </div>
        </ng-container>

        <ng-container *ngIf="moqViolations?.length > 0">
            <p [class.mt-3]="failedProductGtins?.length > 0">
                {{ TEXT.MOQ_NOT_MET }}
            </p>
            <div>
                <p *ngFor="let violation of moqViolations">{{ violation.gtin }}</p>
            </div>
        </ng-container>
    </div>
    <div class="pricelists-page__content">
        <aside class="pricelists-page__sidebar">
            <div class="pricelists-page__filters-header">
                <div class="pricelists-page__filters-title-wrapper">
                    <button class="pricelists-page__filters-toggle" (click)="toggleFilters()">
                        <img
                            class="pricelists-page__filters-icon"
                            alt="Filters"
                            src="../../../../assets/icons/filter-icon.svg"
                        />
                        <h1 class="pricelists-page__filters-title">Filters</h1>
                    </button>
                </div>
                <div>
                    <button
                        type="button"
                        class="pricelists-page__filters-clear"
                        (click)="clearFilters()"
                        [class.pricelists-page__filters-clear--disabled]="!hasActiveFilters()"
                        [disabled]="!hasActiveFilters()"
                    >
                        Clear filters
                    </button>
                </div>
            </div>

            <div class="pricelists-page__filters-container"
                 [class.pricelists-page__filters-container--expanded]="filtersExpanded">

                <div *ngIf="filtersExpanded" class="pricelists-page__filters-modal-header">
                    <div class="pricelists-page__filters-modal-header-row">
                        <h1 class="pricelists-page__filters-modal-title">Filters</h1>
                        <button (click)="closeFilters()">
                            <img
                                alt="Close Button For Filter Modal"
                                src="../../../../assets/icons/close-icon.svg"
                            />
                        </button>
                    </div>
                    <div class="pricelists-page__filters-modal-divider"></div>
                </div>

                <div *ngIf="brandOptions.length > 0"
                     class="pricelists-page__filter-card"
                     [class.pricelists-page__filter-card--expanded]="filtersExpanded">
                    <div class="pricelists-page__filter-card-content">
                        <div class="pricelists-page__filter-card-title">
                            Brands
                        </div>
                        <ul class="pricelists-page__filter-list">
                            <li *ngFor="let brand of brandOptions; let last = last"
                                class="pricelists-page__filter-item"
                                [class.pricelists-page__filter-item--last]="last">
                                <label class="pricelists-page__filter-label"
                                       [class.pricelists-page__filter-label--last]="last">
                                    <div class="pricelists-page__filter-checkbox-wrapper">
                                        <input
                                            type="checkbox"
                                            [checked]="selectedBrands.has(brand)"
                                            (change)="toggleBrandFilter(brand)"
                                            class="pricelists-page__filter-checkbox"
                                        />
                                        <span class="pricelists-page__filter-text">
                                            {{ brand }}
                                        </span>
                                    </div>
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="pricelists-page__filter-card"
                     [class.pricelists-page__filter-card--expanded]="filtersExpanded">
                    <div class="pricelists-page__filter-card-content">
                        <div class="pricelists-page__filter-card-title">
                            <span>Maximum MOV</span>
                            <div class="pricelists-page__filter-tooltip-wrapper">
                                <div
                                    *ngIf="showMovTooltip"
                                    class="pricelists-page__filter-tooltip-overlay"
                                    role="button"
                                    tabindex="0"
                                    aria-label="Close tooltip"
                                    (click)="showMovTooltip = false"
                                    (keydown.enter)="showMovTooltip = false"
                                    (keydown.escape)="showMovTooltip = false"
                                ></div>
                                <img
                                    src="assets/icons/info-circle-outline.svg"
                                    alt=""
                                    class="pricelists-page__filter-tooltip-icon"
                                    (click)="toggleMovTooltip()"
                                />
                                <div
                                    class="pricelists-page__filter-tooltip-popup"
                                    [class.pricelists-page__filter-tooltip-popup--visible]="showMovTooltip"
                                >
                                    <div class="pricelists-page__filter-tooltip-content">
                                        {{ TEXT.MOV_TOOLTIP }}
                                        <div class="pricelists-page__filter-tooltip-arrow"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ul class="pricelists-page__filter-list">
                            <li *ngFor="let filter of movFilters; let last = last"
                                class="pricelists-page__filter-item"
                                [class.pricelists-page__filter-item--last]="last">
                                <label class="pricelists-page__filter-label"
                                       [class.pricelists-page__filter-label--last]="last">
                                    <div class="pricelists-page__filter-checkbox-wrapper">
                                        <input
                                            type="checkbox"
                                            [checked]="selectedMovFilters.has(filter.id)"
                                            (change)="toggleMovFilter(filter.id)"
                                            class="pricelists-page__filter-checkbox"
                                        />
                                        <span class="pricelists-page__filter-text">
                                            {{ filter.label }}
                                        </span>
                                    </div>
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="pricelists-page__filter-card"
                     [class.pricelists-page__filter-card--expanded]="filtersExpanded">
                    <div class="pricelists-page__filter-card-content">
                        <div class="pricelists-page__filter-card-title">
                            Shipping date
                        </div>
                        <ul class="pricelists-page__filter-list">
                            <li *ngFor="let filter of leadTimeFilters; let last = last"
                                class="pricelists-page__filter-item"
                                [class.pricelists-page__filter-item--last]="last">
                                <label class="pricelists-page__filter-label"
                                       [class.pricelists-page__filter-label--last]="last">
                                    <div class="pricelists-page__filter-checkbox-wrapper">
                                        <input
                                            type="checkbox"
                                            [checked]="selectedLeadTimeFilters.has(filter.id)"
                                            (change)="toggleLeadTimeFilter(filter.id)"
                                            class="pricelists-page__filter-checkbox"
                                        />
                                        <span class="pricelists-page__filter-text">
                                            {{ filter.label }}
                                        </span>
                                    </div>
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>

                <div *ngIf="filtersExpanded" class="pricelists-page__filters-apply-wrapper">
                    <button
                        (click)="closeFilters()"
                        class="pricelists-page__filters-apply-btn"
                    >
                        Apply Filters
                    </button>
                </div>
            </div>
        </aside>

        <div class="pricelists-page__main">
            <ng-container *ngIf="loading; else pricelistsLoaded">
                <vsf-product-skeleton [count]="5"></vsf-product-skeleton>
            </ng-container>

            <ng-template #pricelistsLoaded>
                <ng-container *ngIf="paginatedPricelists.length > 0; else noResults">
                    <div class="pricelists-page__list">
                        <vsf-pricelist-card
                            *ngFor="let pricelist of paginatedPricelists; trackBy: trackByPricelist"
                            [pricelist]="pricelist"
                            [isPreOrder]="isPreOrderPage"
                            (viewClick)="onViewPricelist($event)"
                            (downloadClick)="onDownloadPricelist($event)"
                            (shareClick)="onSharePricelist($event)"
                        ></vsf-pricelist-card>
                    </div>

                    <div class="pricelists-page__pagination" *ngIf="totalPages > 1">
                        <div class="pricelists-page__pagination-info">
                            <span class="pricelists-page__pagination-label">{{ TEXT.SHOW_LABEL }}</span>
                            <select
                                class="pricelists-page__pagination-select"
                                [ngModel]="itemsPerPage"
                                (ngModelChange)="onItemsPerPageChange($event)"
                            >
                                <option *ngFor="let option of ITEMS_PER_PAGE_OPTIONS" [value]="option">
                                    {{ option }}
                                </option>
                            </select>
                            <span class="pricelists-page__pagination-label">{{ TEXT.PER_PAGE }}</span>
                        </div>

                        <div class="pricelists-page__pagination-summary">
                            {{ TEXT.PAGE_OF }} {{ currentPage }} {{ TEXT.OF }} {{ totalPages }}
                            ({{ filteredPricelists.length }} {{ TEXT.TOTAL_RESULTS }})
                        </div>

                        <div class="pricelists-page__pagination-controls">
                            <button
                                (click)="goToFirstPage()"
                                [disabled]="!canGoPrevious"
                                class="pricelists-page__pagination-btn"
                                title="Go to first page"
                            >
                                <span class="hidden sm:inline">{{ TEXT.FIRST }}</span>
                                <span class="sm:hidden">«</span>
                            </button>

                            <button
                                (click)="goToPreviousPage()"
                                [disabled]="!canGoPrevious"
                                class="pricelists-page__pagination-btn"
                            >
                                <span class="hidden sm:inline">{{ TEXT.PREVIOUS }}</span>
                                <span class="sm:hidden">‹</span>
                            </button>

                            <div class="pricelists-page__pagination-pages">
                                <button
                                    *ngFor="let page of getPageNumbers()"
                                    (click)="goToPage(page)"
                                    class="pricelists-page__pagination-btn"
                                    [class.pricelists-page__pagination-btn--active]="currentPage === page"
                                >
                                    {{ page }}
                                </button>
                            </div>

                            <div class="pricelists-page__pagination-mobile-info">
                                {{ currentPage }} / {{ totalPages }}
                            </div>

                            <button
                                (click)="goToNextPage()"
                                [disabled]="!canGoNext"
                                class="pricelists-page__pagination-btn"
                            >
                                <span class="hidden sm:inline">{{ TEXT.NEXT }}</span>
                                <span class="sm:hidden">›</span>
                            </button>

                            <button
                                (click)="goToLastPage()"
                                [disabled]="!canGoNext"
                                class="pricelists-page__pagination-btn"
                                title="Go to last page"
                            >
                                <span class="hidden sm:inline">{{ TEXT.LAST }}</span>
                                <span class="sm:hidden">»</span>
                            </button>
                        </div>
                    </div>
                </ng-container>

                <ng-template #noResults>
                    <div class="pricelists-page__empty">
                        <img
                            class="pricelists-page__empty-icon"
                            src="assets/icons/information-icon.svg"
                            alt=""
                        />
                        <p class="pricelists-page__empty-text">{{ TEXT.NO_RESULTS }}</p>
                    </div>
                </ng-template>
            </ng-template>
        </div>
    </div>
</div>
